import { useState } from 'react'
import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'
import { ChevronDown } from 'lucide-react'

interface FAQProps {
  title: string
  titleEn?: string
  items: Array<{
    question: string
    questionEn?: string
    answer: string
    answerEn?: string
  }>
}

export default function FAQBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as FAQProps
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.items && p.items.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-3xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="space-y-3">
          {(p.items || []).map((item, i) => {
            const isOpen = openIndex === i
            const question = lang === 'en' && item.questionEn ? item.questionEn : item.question
            const answer = lang === 'en' && item.answerEn ? item.answerEn : item.answer
            return (
              <div key={i} className="rounded-xl border border-black/[0.04] overflow-hidden">
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                >
                  <span className="text-sm font-medium" style={{ color: branding.secondaryColor }}>{question}</span>
                  <ChevronDown className={`h-4 w-4 text-gray-400 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                </button>
                {isOpen && (
                  <div className="px-5 pb-4 text-xs text-gray-500 leading-relaxed whitespace-pre-wrap">
                    {answer}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
